import { render, staticRenderFns } from "./entry-list.vue?vue&type=template&id=28a3f38b&scoped=true&"
import script from "./entry-list.vue?vue&type=script&lang=js&"
export * from "./entry-list.vue?vue&type=script&lang=js&"
import style0 from "./entry-list.vue?vue&type=style&index=0&id=28a3f38b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a3f38b",
  null
  
)

export default component.exports